/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const GET_PATIENTS_API_V2_ENABLED = "patients-api-v2-enabled";

export const USER_AGREEMENTS_ENABLED = "gnp-4968-user-agreements-annual-attestation";

export const BANNER_BILLING_REPORT_ENABLED = "gnp-5310-banner-for-billing-report-page";

export const CPT_CODES_ENABLED = "hpi-689-cpt-codes";

export const ESIGN_ENHANCEMENT = "hpi-781-esigning-enhancement-and-save-filters";

export const V2_FEATURES = "v2-features";
